<template>
    <AdaptersDropdown
        v-model="selectedTop"
        :options="tops"
        optionLabel="label"
        optionValue="value"
        panelClass="p-dropdown-panel-sm"
        inputClass="p-input-sm"
        @change="onUpdate"
    />
</template>

<script>
import {Listeners} from "../../constants/listeners";
import AdaptersDropdown from "../adapters/Dropdown.vue";

export default {
    name: "TopSelect",
    props: {
        top: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {
            selectedTop: 10,
            tops: [
                { label: "Топ 10", value: 10 },
                { label: "Топ 50", value: 50 }
            ],
        }
    },
    created() {
        this.selectedTop = this.top
    },
    methods: {
        onUpdate() {
            this.$emitter.emit(Listeners.KS_TOP_CHANGE, {top: this.selectedTop})
            this.$emitter.emit(Listeners.KS_TABLE_CLEAR_SELECTED_TO)
        }
    },
    components: {
        AdaptersDropdown,
    }
}
</script>
